import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import { PageTitle } from '../../../components';
import { useAuthUser } from '../../../../model/hooks';
import QRCode from 'qrcode.react';
export const Checkin = () => {
    const { t } = useTranslation();
    const { user } = useAuthUser();
    const [qrCodeValue, setQrCodeValue] = useState();
    useEffect(() => {
        if (user !== undefined) {
            setQrCodeValue(`{"clinicId": "${user.uid}"}`);
        }
    }, [user]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('チェックイン管理')),
        React.createElement(SGrid, { container: true, alignItems: "center", justify: "center" },
            React.createElement(Grid, { item: true, xs: 11, md: 6 },
                React.createElement("p", null,
                    React.createElement("strong", null, t('こちらのQRコードをチェックインするワーカーに読み込ませてください。'))),
                React.createElement(SPaper, null,
                    React.createElement(SPaperContent, null,
                        React.createElement(SPaperTitle, null, t('読み取りQRコード')),
                        React.createElement(Divider, { style: { marginBottom: '32px' } }),
                        qrCodeValue !== undefined && React.createElement(QRCode, { value: qrCodeValue }))),
                React.createElement("p", null,
                    React.createElement("strong", null, t('クリニックの方へ'))),
                React.createElement("p", null, t('ワーカーさんが働きにきた時には必ずこのQRコードを見せてイモリーのアプリから読み込んでもらいましょう。QRコードの読み取りをしないとマッチング完了にならず、問題が発生する可能性がありますのでご注意ください。'))))));
};
const SGrid = styled(Grid) `
  padding-top: 40px;
  padding-bottom: 40px;
`;
const SPaper = styled(Paper) `
  margin-top: 32px;
  margin-bottom: 32px;
`;
const SPaperContent = styled.div `
  padding: 24px;
  text-align: center;
`;
const SPaperTitle = styled.p `
  font-size: 22px;
  font-weight: bold;
`;
